import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { adminApi, AdminInvite } from '../api/admin';

export default function AdminInvites() {
  const { getToken } = useAuth();
  const [invites, setInvites] = useState<AdminInvite[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const t = await getToken();
        setInvites(await adminApi.listInvites(t));
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
      }
    })();
  }, [getToken]);

  return (
    <div>
      <h1 style={{ color: 'var(--mi-navy)' }}>Invites</h1>
      {error && <div style={{ background: '#fee', padding: 12, borderRadius: 6 }}>{error}</div>}
      {!invites ? (
        <div>Loading…</div>
      ) : invites.length === 0 ? (
        <div className="card">No invites yet.</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'var(--mi-surface)', border: '1px solid var(--mi-border)', borderRadius: 8, overflow: 'hidden' }}>
          <thead>
            <tr style={{ background: '#f1f3f5' }}>
              <th style={th}>Email</th>
              <th style={th}>Client</th>
              <th style={th}>Status</th>
              <th style={th}>Expires</th>
            </tr>
          </thead>
          <tbody>
            {invites.map((i) => (
              <tr key={i.id}>
                <td style={td}>{i.email}</td>
                <td style={td}>{i.client_name}</td>
                <td style={td}>{statusBadge(i)}</td>
                <td style={td}>{new Date(i.expires_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

function statusBadge(i: AdminInvite) {
  if (i.accepted_at) return <span style={{ color: 'var(--mi-green)' }}>Accepted</span>;
  if (new Date(i.expires_at) < new Date()) return <span style={{ color: 'var(--mi-muted)' }}>Expired</span>;
  return <span style={{ color: 'var(--mi-gold)' }}>Pending</span>;
}

const th: React.CSSProperties = { textAlign: 'left', padding: '10px 12px', borderBottom: '1px solid var(--mi-border)', fontSize: 13 };
const td: React.CSSProperties = { padding: '10px 12px', borderBottom: '1px solid var(--mi-border)' };
